<template>
	<div class="edit-row--template scrollbar-custom">
		<div class="dashed-row mb--15">
			<div @click="templateChoose(TEMPLATE_VALUE.NONE.VALUE)" class="dashed-item flex--grow">
				<span
					:class="{'color--rosy-pink': templateName === TEMPLATE_VALUE.NONE.VALUE}"
					class="font-weight--500"
				>{{ TEMPLATE_VALUE.NONE.NAME }}</span>
			</div>
			<div @click="templateChoose(TEMPLATE_VALUE.GLOBAL.VALUE)" class="dashed-item flex--grow">
				<span
					:class="{'color--rosy-pink': templateName === TEMPLATE_VALUE.GLOBAL.VALUE}"
					class="font-weight--500"
				>{{ TEMPLATE_VALUE.GLOBAL.NAME }}</span>
			</div>
			<div class="icon-row ml--10 mr--10">
				<div :class="{active: viewActive === VIEW.THUMB}" @click="viewChange(VIEW.THUMB)" class="icon-item mr--15"><i class="fas fa-th"></i></div>
				<div :class="{active: viewActive === VIEW.LIST}" @click="viewChange(VIEW.LIST)" class="icon-item"><i class="fas fa-th-list"></i></div>
			</div>
		</div>
		<div v-if="viewActive === VIEW.THUMB" class="element-box element-box--edit-bar">
			<template
				v-for="(template, $indexTemplate) of objectTemplates"
				:key="`node-${$indexTemplate}`"
			>
				<div
					v-if="template.type === TEMPLATE_TYPES.EDGE"
					@click="templateChoose(template.name)"
					class="element-link element-link--edit-bar"
				>
					<div
						:class="{'active': template.name === templateName}"
						class="element-preview element-preview--edit-bar cursor--pointer">
						<header class="element-preview__header">
							<span>B. {{ template.borderWidth }}px</span>
							<span>{{ t('objectTemplate.font') }} {{ template.fontSize }}px</span>
						</header>
						<img :src="template.snapshot" alt="">
					</div>
					<div class="element-link__field">
						<span>{{ template.name }}</span>
					</div>
				</div>
			</template>
		</div>
		<div class="dashed-box" v-else>
			<template
				v-for="(template, $indexTemplate) of objectTemplates"
				:key="`node-${$indexTemplate}`"
			>
				<div
					v-if="template.type === TEMPLATE_TYPES.EDGE"
					@click="templateChoose(template.name)"
					class="dashed-item mb--10"
				>
					<div class="dashed-item__wrapper">
						<span
							:class="{'color--rosy-pink': template.name === templateName}"
							class="font-weight--500 flex--grow">{{ template.name }}</span>
						<div class="dashed-item__wrapper">
							<span class="mr--30">B. {{ template.borderWidth }}px</span>
							<span>{{ t('objectTemplate.font') }} {{ template.fontSize }}px</span>
						</div>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import {ref, computed} from 'vue';
import {useI18n} from 'vue-i18n';
import {useStore} from 'vuex';
import {SE_SYNC_TYPES} from '@/models/SE_SYNC_TYPES';
import {TEMPLATE_VALUE} from "@/models/TEMPLATE_VALUE";
import {TEMPLATE_TYPES} from "@/models/TEMPLATE_TYPES";
export default {
	setup() {
		const {t} = useI18n();
		const store = useStore();
		
		const clientRestrictions = computed(() => store.getters["clients/getRestrictions"]);
		const canSelectDesignTemplates = computed(() => clientRestrictions.value.canSelectDesignTemplates.value);
		
		const templates = computed(() => store.getters["design/getEdgesTemplates"]);
		const templateOptions = computed(() => [TEMPLATE_VALUE.NONE.VALUE, TEMPLATE_VALUE.GLOBAL.VALUE, ...Object.values(templates.value).map(template => template.name)]);
		const currentEdge = computed(() => store.getters['edges/getSelectedEdge']);
		const currentEdgeOriginal = computed(() => store.getters['edges/getSelectedRawEdge']);
		const isTemplateChangesTracked = computed(() => store.getters["edges/isTemplateChangesTracked"]);
		
		function edgeUpdate(edgeData) {
			store.dispatch('edges/saveEditedEdge', edgeData);
		}
		
		const objectTemplates = computed(() => store.getters["templates/getObjectTemplates"]);
		if(!objectTemplates.value.length) objectTemplatesInit();
		
		const templateName = computed({
			get() {
				return currentEdge.value.template === '0' ? TEMPLATE_VALUE.GLOBAL.VALUE : templates.value[currentEdge.value.template]?.name || TEMPLATE_VALUE.NONE.VALUE
			},
			set(value) {
				edgeUpdate({edgeId: currentEdge.value.id, edgeData: {template: getTemplateId(value)}});
				templateApply(getTemplateId(value));
			}
		})
		
		function templateChoose(templateName){
			edgeUpdate({edgeId: currentEdge.value.id, edgeData: {template: getTemplateId(templateName)}});
			templateApply(getTemplateId(templateName));
		}
		
		async function templateApply(templateId) {
			const edgeId = currentEdgeOriginal.value.id;
			await store.dispatch('edges/applyTemplate', {templateId, edgeId});
			const edgeDesign = currentEdgeOriginal.value.design;
			await store.dispatch('edges/saveEdgeDesignByTemplate', {edgeData: edgeDesign, edgeId, type: SE_SYNC_TYPES.EDGE_TEMPLATE_APPLIED});
		}
		
		function getTemplateId(name) {
			if (name === TEMPLATE_VALUE.NONE.VALUE) return null;
			if (name === TEMPLATE_VALUE.GLOBAL.VALUE) return '0';
			for (let [key, value] of Object.entries(templates.value)) {
				if (value.name === name) return key;
			}
		}
		
		// VIEW
		const VIEW = {
			THUMB: 'THUMB',
			LIST: 'LIST'
		}
		const viewActive = ref(VIEW.THUMB);
		function viewChange(view){
			viewActive.value = view;
		}
		
		// STORE ACTIONS
		function objectTemplatesInit(){
			store.dispatch("templates/objectTemplatesInit");
		}
		
		return {
			t,
			canSelectDesignTemplates,
			templateOptions,
			templateName,
			isTemplateChangesTracked,
			objectTemplates,
			TEMPLATE_TYPES,
			TEMPLATE_VALUE,
			templateChoose,
			viewActive,
			viewChange,
			VIEW,
		}
	}
}
</script>

<style lang="scss">

</style>
